import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-loading-dialog',
  standalone: true,
  imports: [
    MatProgressSpinnerModule
],
  templateUrl: './loading-dialog.html',
  styleUrl: './loading-dialog.scss'
})
export class LoadingDialog{
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) { }
}